import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

/**
 * Sind simulierte Läufe erlaubt (Mock-Agent, Demo-Auftrag, Beispiele)? Nur in Tests und lokaler Entwicklung;
 * im Büro sind sie aus, dort zählt nur echte Arbeit. Bis zur Antwort des Servers gilt: aus.
 */
export function useSimulation(): boolean {
  const health = useQuery({ queryKey: ["health"], queryFn: api.health, refetchInterval: 60_000 });
  return health.data?.simulation ?? false;
}
